import _ from 'lodash';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { SharedService } from 'app/virtual-event/services/shared.service';
import { updateVirtualEventPresent } from 'app/virtual-event/features/data/data.actions';
import { selectCampaignSelected, selectCampaignOptionSelected } from 'app/campaign/features/campaign.selectors';
import { AUCTION_TYPE, CAMPAIGN_TYPE, CAMPAIGN_TYPE_NAME, AUCTION_STATUS } from '../../virtual-event.enums';
import { openDialog } from 'app/dialog/features/dialog.actions';
import { of } from 'rxjs';
import { first, combineAll, filter } from 'rxjs/operators';
import { selectVirtualEventData } from '../../features/data/data.selectors';
import { selectOption } from 'app/campaign/features/campaign.actions';
import { selectPlaylistLayoutHeight } from 'app/core/features/layout.selectors';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlaylistComponent implements OnInit {
  destroyRef = inject(DestroyRef)
  public height$: any = this.store.pipe(select(selectPlaylistLayoutHeight));
  public data$: any = this.store.pipe(select(selectVirtualEventData));
  public selectedCampaign$: any = this.store.pipe(select(selectCampaignSelected));
  public selectedOption$: any = this.store.pipe(select(selectCampaignOptionSelected));
  
  constructor(
    private store: Store<any>,
    private shareService: SharedService
  ) { }

  ngOnInit(): void {
    of(this.data$, this.selectedCampaign$).pipe(
      combineAll(),
      filter((results: any) => {
        const id = _.get(results[0], 'id', null);
        return !_.isNull(id);
      }),
      filter((results: any) => !_.isNull(results[1])),
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(results => {
      const data = results[0];
      const campaign = results[1];
      const options = _.get(campaign, 'campaignTypeData.presetOptions', []);

      const id = _.get(data, 'currentItem.currentOption', null);
      const option = _.find(options, { id }) || null;

      if(!_.isNull(option)) {
        this.store.dispatch({
          type: selectOption.type,
          payload: option.id
        });
      }
    })
  } 

  getImageUrl(option) {
    return option.imageUrl === '' ? '/images/blank-image.png': option.imageUrl;
  }

  getCampaignOptionClassList(option) {
    const result = {
      'campaign-option': true
    }
    this.selectedOption$.pipe(
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(selected => {
      const id = _.get(selected, 'id', null);
      _.set(result, 'campaign-option--selected', _.isEqual(id, option.id));
    })
    return result;
  }

  getCampaignType(campaign) {
    switch(campaign.type) {
      case CAMPAIGN_TYPE.AUCTION:
        return this.isSilentAuction(campaign) ?
          CAMPAIGN_TYPE_NAME.SILENT_AUCTION:
          CAMPAIGN_TYPE_NAME.LIVE_AUCTION;
      case CAMPAIGN_TYPE.DONATE:
        return CAMPAIGN_TYPE_NAME.DONATION;
      case CAMPAIGN_TYPE.LAST_HERO:
        return CAMPAIGN_TYPE_NAME.LAST_HERO;
    }
    return CAMPAIGN_TYPE_NAME.NONE;
  }

  onPresent(campaignId, option, clear = false) {
    this.store.dispatch({
      type: updateVirtualEventPresent.type,
      payload: {
        eventId: this.shareService.id,
        campaignId, option, clear
      }
    });
  }

  isNotAuction(campaign) {
    return !_.isEqual(campaign.type, CAMPAIGN_TYPE.AUCTION);
  }

  isSilentAuction(campaign) {
    const type = _.get(campaign, 'campaignTypeData.auctionType', 1);
    return _.isEqual(AUCTION_TYPE.SILENT, type);
  }

  isSilentAuctionClosed(campaign) {
    const status = _.get(campaign, 'campaignTypeData.auctionStatus', null);
    switch(status) {
      case AUCTION_STATUS.FINALIZED:
        return true;
    }
    return false;
  }

  openCloseSilentAuctionDialog(campaign) {
    this.store.dispatch({
      type: openDialog.type,
      payload: {
        name: 'closeSilentAuction',
        options: {
          size: 'small',
          modalClass:'modal--paybee modal-sm',
          containerClass:'mdb-modal-backdrop-paybee modal--close-silent-auction'
        },
        initialState: {
          vEventId: this.shareService.id,
          campaign: campaign
        }
      }
    });
  }

}
